import api from './api';

// 通知任务类型
export interface NotificationTask {
  id: string;
  name: string;
  type: string; // http_request, vaccine_reminder, dose_reminder
  apiUrl?: string;
  httpMethod?: string;
  requestParams?: string;
  vaccineTypeId?: string;
  vaccineTypeName?: string;
  cronExpression?: string;
  notificationMethod: string; // system, sms, email, wechat
  notificationTemplate?: string;
  isEnabled: boolean;
  lastRunTime?: string;
  nextRunTime?: string;
  runCount: number;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

// 通知记录类型
export interface NotificationLog {
  id: string;
  taskId: string;
  taskName?: string;
  userId?: string;
  userName?: string;
  userPhone?: string;
  planId?: string;
  doseId?: string;
  notificationMethod?: string;
  notificationContent?: string;
  status: string; // pending, sent, failed
  errorMessage?: string;
  sentAt?: string;
  createdAt: string;
}

// 创建任务请求
export interface CreateTaskRequest {
  name: string;
  type: string;
  vaccineTypeId?: string;
  vaccineTypeName?: string;
  cronExpression?: string;
  notificationMethod?: string;
  notificationTemplate?: string;
  isEnabled?: boolean;
  apiUrl?: string;
  httpMethod?: string;
  requestParams?: string;
}

// 更新任务请求
export interface UpdateTaskRequest {
  name?: string;
  type?: string;
  vaccineTypeId?: string;
  vaccineTypeName?: string;
  cronExpression?: string;
  notificationMethod?: string;
  notificationTemplate?: string;
  isEnabled?: boolean;
  apiUrl?: string;
  httpMethod?: string;
  requestParams?: string;
}

// 分页参数
export interface ListParams {
  page?: number;
  pageSize?: number;
  type?: string;
  isEnabled?: boolean;
}

// 通知任务服务
export const notificationTaskService = {
  // 获取任务列表
  list: async (params?: ListParams) => {
    const response = await api.get('/notification-tasks', { params });
    return response.data;
  },

  // 获取单个任务
  getById: async (id: string) => {
    const response = await api.get(`/notification-tasks/${id}`);
    return response.data;
  },

  // 创建任务
  create: async (data: CreateTaskRequest) => {
    const response = await api.post('/notification-tasks', data);
    return response.data;
  },

  // 更新任务
  update: async (id: string, data: UpdateTaskRequest) => {
    const response = await api.put(`/notification-tasks/${id}`, data);
    return response.data;
  },

  // 删除任务
  delete: async (id: string) => {
    const response = await api.delete(`/notification-tasks/${id}`);
    return response.data;
  },

  // 切换启用状态
  toggleEnabled: async (id: string) => {
    const response = await api.post(`/notification-tasks/${id}/toggle`);
    return response.data;
  },

  // 立即执行任务
  execute: async (id: string) => {
    const response = await api.post(`/notification-tasks/${id}/execute`);
    return response.data;
  },

  // 获取任务的通知记录
  getLogs: async (id: string, page = 1, pageSize = 10) => {
    const response = await api.get(`/notification-tasks/${id}/logs`, {
      params: { page, pageSize }
    });
    return response.data;
  },

  // 获取所有通知记录
  getAllLogs: async (params: {
    page?: number;
    pageSize?: number;
    userName?: string;
    userPhone?: string;
    startDate?: string;
    endDate?: string;
  } = {}) => {
    const response = await api.get('/notification-tasks/logs/all', {
      params: {
        page: params.page || 1,
        pageSize: params.pageSize || 10,
        userName: params.userName,
        userPhone: params.userPhone,
        startDate: params.startDate,
        endDate: params.endDate
      }
    });
    return response.data;
  }
};

export default notificationTaskService;
